import { render, staticRenderFns } from "./ExportTab.vue?vue&type=template&id=6f321cb5&"
import script from "./ExportTab.vue?vue&type=script&lang=ts&"
export * from "./ExportTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports